import { imgSrcSetFull, imgPathWithTransforms } from '../../../logged_out_homepage/utils/image';
import { XLRG_IMAGE, LRG_IMAGE, MED_IMAGE, DPR_1 } from '../../../logged_out_homepage/utils/constants';

const XLARGE_WIDTH = 870;
const LARGE_WIDTH = 585;
const MED_WIDTH = 800;

const ImgPath = '2321104e0c585cceea525419551d3a7c-1721984733481/fiverr-pro.png';
const RetinaImgPath = '2321104e0c585cceea525419551d3a7c-1721984733469/fiverr-pro_2x.png';

export const pictureData = [
    {
        srcSet: imgSrcSetFull({
            width: XLARGE_WIDTH,
            img: ImgPath,
            retinaImg: RetinaImgPath,
        }),
        media: XLRG_IMAGE,
    },
    {
        srcSet: imgSrcSetFull({
            width: LARGE_WIDTH,
            img: ImgPath,
            retinaImg: RetinaImgPath,
        }),
        media: LRG_IMAGE,
    },
    {
        srcSet: imgSrcSetFull({
            width: MED_WIDTH,
            img: ImgPath,
            retinaImg: RetinaImgPath,
        }),
        media: MED_IMAGE,
    },
];

export const copyData = {
    title: 'logged_out_homepage.business.title',
    list: [
        {
            title: 'logged_out_homepage.business.experts.title',
            content: 'logged_out_homepage.business.experts.content',
        },
        {
            title: 'logged_out_homepage.business.guarantee.title',
            content: 'logged_out_homepage.business.guarantee.content',
        },
        {
            title: 'logged_out_homepage.business.tools.title',
            content: 'logged_out_homepage.business.tools.content',
        },
        {
            title: 'logged_out_homepage.business.payment.title',
            content: 'logged_out_homepage.business.payment.content',
        },
    ],
    cta: 'logged_out_homepage.business.cta',
    alt: 'logged_out_homepage.business.alt',
};

export const imgSrc = imgPathWithTransforms({ width: XLARGE_WIDTH, dpr: DPR_1, img: ImgPath });
